import Loader from "./Loader";
import {FlexBox} from "../../../styles/layout/boxes";
import {FC} from "react";

const FullPageLoader: FC = () => {
    return (
        <FlexBox sx={{width: '100vw', height: '100vh'}}>
            <Loader />
        </FlexBox>
    );
};

export default FullPageLoader;